module.exports = __webpack_public_path__ + "static/media/resume.6a50cf3a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/resume.pdf
// module id = 239
// module chunks = 1